import { Dto, DtoWithId } from "@mango/core";


@Dto({fullName: "CIJBorculo.Logic.Merk"})
export class Merk extends DtoWithId {
	omschrijving: string;
}